import React, { useState } from 'react'
import { Container } from './styles'

const Search = ({ placeholder, onSearch, margin }) => {
  const [value, setValue] = useState('')

  const handleChange = (e) => {
    setValue(e.target.value)
    onSearch(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSearch(value)
  }

  return (
    <Container margin={margin}>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
        />
      </form>
    </Container>
  )
}

export default Search
